module.exports = __webpack_public_path__ + "assets/img/investmentAdviser.e3dd099d.png";